{
  "name": "web-frontend",
  "version": "1.0.0-beta.26",
  "scripts": {
    "ng": "ng",
    "start": "ng serve --port 4201",
    "build": "ng build",
    "watch": "ng build --watch --configuration development",
    "build:dev": "ng build --configuration development",
    "test": "ng test",
    "test:architecture": "node scripts/architecture-check.mjs",
    "repomix:generate": "repomix",
    "repomix:skills": "repomix --skill-generate"
  },
  "prettier": {
    "overrides": [
      {
        "files": "*.html",
        "options": {
          "parser": "angular"
        }
      }
    ]
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^20.3.14",
    "@angular/cdk": "^20.2.14",
    "@angular/common": "^20.3.14",
    "@angular/compiler": "^20.3.14",
    "@angular/core": "^20.3.14",
    "@angular/forms": "^20.3.14",
    "@angular/platform-browser": "^20.3.14",
    "@angular/platform-browser-dynamic": "^20.3.14",
    "@angular/router": "^20.3.14",
    "@fortawesome/angular-fontawesome": "^3.0.0",
    "@fortawesome/free-regular-svg-icons": "^7.2.0",
    "@fortawesome/free-solid-svg-icons": "^7.2.0",
    "@jsverse/transloco": "^8.3.0",
    "@jsverse/transloco-locale": "^8.3.0",
    "@tailwindcss/postcss": "^4.1.12",
    "angularx-qrcode": "^20.0.0",
    "echarts": "^6.0.0",
    "flowbite": "^3.1.2",
    "ngx-echarts": "^20.0.1",
    "rxjs": "~7.8.0",
    "tailwindcss": "^4.1.12",
    "tslib": "^2.3.0",
    "zone.js": "~0.15.1"
  },
  "devDependencies": {
    "@angular/build": "^20.3.12",
    "@angular/cli": "^20.3.12",
    "@angular/compiler-cli": "^20.3.14",
    "@tailwindcss/forms": "^0.5.10",
    "@types/jasmine": "~5.1.0",
    "concurrently": "^9.2.0",
    "jasmine-core": "~5.8.0",
    "karma": "~6.4.0",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.0",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.1.0",
    "postcss": "^8.5.6",
    "repomix": "^1.11.1",
    "typescript": "~5.8.3"
  }
}
